<template>
  <pict
    class="error-image__image m-auto"
    style="max-width: 343px"
    block-name="error-image"
    :default="imageProps.default"
    :sources="imageProps.sources"
    :alt="$t('alt')"
  />
</template>

<script>
import Pict from "@/shared/pict"
import imageL from "../images/error.png"
import imageL2x from "../images/error@2x.png"
import imageM from "../images/error_m.png"
import imageM2x from "../images/error_m@2x.png"
import imageS from "../images/error_s.png"
import imageS2x from "../images/error_s@2x.png"
export default {
  name: "ErrorImage",
  components: {
    Pict
  },
  computed: {
    imageProps() {
      return {
        default: {
          src: imageL,
          srcset: {
            "2x": imageL2x
          }
        },
        sources: [
          {
            media: "s",
            src: imageS,
            srcset: {
              "2x": imageS2x
            }
          },
          {
            media: "m",
            src: imageM,
            srcset: {
              "2x": imageM2x
            }
          }
        ]
      }
    }
  },
  i18n: {
    messages: {
      en: {
        alt: "Illustration of a blue ice cream with white, dark blue, and yellow sprinkles in a waffle cone, which has fallen and begun to melt. Above it is a capitalized text reading “OOPS!”"
      },
      de: {
        alt: 'Illustration einer blauen Kugel Eis mit Streuseln in einer Waffel, die umgefallen ist und schon schmilzt. Darüber steht in Großbuchstaben der Text "OOPS!".'
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.error-image {
  ::v-deep &__image {
    width: 100%;
  }
}
</style>
